/*
An app user's virtual device (an alarms row with user_id: the person's SOS
button, provisioned by securcloud) has no test alarm. Starting one would stamp
a ten-minute window in which SecurARC shows the person's presses as "test
alarm received" instead of red, and confirming one would close their live
alarm on every phone (audit 3, item 43). So securcloud refuses both, before
anything is written, with

  409 { error_code: "virtual_device_no_test", message }

from POST /alarm/init-test/:imei, GET /alarm/confirm-test-alarm/:alarm_id and
POST /device-event-tunneling/disable/:imei. The pages that call those show a
sentence that says why, in the reader's language, instead of "Något problem
uppstod" — which read as a fault to retry.
*/
export const VIRTUAL_DEVICE_NO_TEST = "virtual_device_no_test";

export function isVirtualDeviceNoTest(error) {
  const response = error && error.response;
  if (!response || response.status !== 409 || !response.data) return false;
  return response.data.error_code === VIRTUAL_DEVICE_NO_TEST || response.data.code === VIRTUAL_DEVICE_NO_TEST;
}

// An app user's virtual device: an alarms row with user_id (securcloud's
// isVirtual in alarms/services/virtual_device.js).
export function isVirtualDevice(alarm) {
  return !!(alarm && alarm.user_id);
}

// securcloud's addon that switches the mobile alarm function on
// (alarms/services/virtual_device.js MOBILE_ALARM_ADDON).
export const MOBILE_ALARM_ADDON = "mobile_alarm_function";

// Whether a customer or department row carries that addon, compared the way
// securcloud's carriesAddon compares it. true / false when the row says, null
// when this page was not given the row's `addons` (the /customer list omits
// them for reseller and superuser logins) — "unknown" is not "no", and
// treating it as no is how the move question went missing.
export function hasMobileAlarmAddon(row) {
  if (!row || !Array.isArray(row.addons)) return null;
  return row.addons.some((a) => typeof a === "string" && a.toLowerCase() === MOBILE_ALARM_ADDON);
}
